// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3736":"c20eb223","5661":"9bd64952","6571":"ff366b65","6955":"9bd64952","8123":"e45b6d06"}[chunkId] + ".css";
};